import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/img/home/backvido.mp4'


const _withScopeId = n => (_pushScopeId("data-v-203496fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home-six" }
const _hoisted_2 = { class: "six-conten outer-package" }
const _hoisted_3 = {
  class: "title global-title wow bounceInUp",
  "data-wow-duration": "2s"
}
const _hoisted_4 = {
  class: "some wow bounceInUp",
  "data-wow-duration": "1.5s"
}
const _hoisted_5 = {
  key: 0,
  class: "btn"
}
const _hoisted_6 = {
  key: 1,
  class: "btn"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "six-write" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "six-black" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "six-conten-video outer-package wow bounceInUp",
  "data-wow-duration": "1s"
}, [
  /*#__PURE__*/_createElementVNode("video", {
    src: _imports_0,
    muted: "",
    autoplay: "",
    loop: ""
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.txt), 1),
      _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.content), 1),
      (_ctx.isAigc)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("button", {
              class: "wow bounceIn btn-animation1",
              "data-wow-duration": "1s",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.routGo('/information')))
            }, "申请试用"),
            _createElementVNode("button", {
              class: "wow bounceIn btn-animation3",
              "data-wow-duration": "1s",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.routGo('/introduce')))
            }, "产品咨询")
          ]))
        : _createCommentVNode("", true),
      (_ctx.isAigc===false)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("button", {
              class: "wow bounceIn btn-animation1",
              "data-wow-duration": "1s",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeAigcStatus(true)))
            }, "申请试用"),
            _createElementVNode("button", {
              class: "wow bounceIn btn-animation3",
              "data-wow-duration": "1s",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.routGo('/introduce')))
            }, "产品咨询")
          ]))
        : _createCommentVNode("", true)
    ]),
    _hoisted_7,
    _hoisted_8,
    _hoisted_9
  ]))
}